export default __webpack_public_path__ + "static/media/legend-desktop.4f3d7db2.svg";